export default __webpack_public_path__ + "static/media/image1-edit.7691ae3f.jpg";